import React, { useState } from "react";
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from "../../i18n/useTranslation";

export default function CodeStep({
  phoneE164,
  code,
  setCode,
  onBack,
  onClose,
  onVerifyOtp,
  loading,
  error
}) {
  const { t } = useTranslation();

  const [localError, setLocalError] = useState("");

  const handleContinue = () => {
    setLocalError("");

    const clean = (code || "").trim();

    // Firebase = souvent 6 digits mais on tolère 4–6
    if (!/^\d{4,6}$/.test(clean)) {
      setLocalError("Code invalide");
      return;
    }

    onVerifyOtp();
  };

  return (
    <>
      <div className="modal-text-container modal-container">

        <ArrowLeftOutlined className="auth-back" onClick={onBack} />

        <div className="modal-header-container">
          <p className="modal-text-header">
            {t("enter_code")}
          </p>
        </div>

        <p className="auth-helper">
          {t("code_sent_to")} {phoneE164}
        </p>

        <input
          className="auth-input"
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setLocalError("");
          }}
          placeholder="Code reçu"
          inputMode="numeric"
        />

        {(localError || error) && (
          <p className="auth-error">
            {localError || error}
          </p>
        )}
      </div>

      <div className="modal-close-container">
        <div
          className="modal-close-button"
          onClick={loading ? undefined : handleContinue}
          style={{ pointerEvents: loading ? "none" : "auto" }}
        >
          {loading ? <LoadingOutlined spin /> : t("continue")}
        </div>
      </div>
    </>
  );
}